import React, { Component, PropTypes } from 'react'
import Link from 'react-router/lib/Link'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { Form, actions } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'
import SearchIcon from 'react-icons/lib/md/search'
import moment from 'moment'
import isInt from 'validator/lib/isInt'
import Loading from 'bisu-react-loading'

import { required } from 'utils/validators'

import FormPayment from './form-payment'
import { searchStudent, savePayment, loadUnpaidBilling } from './actions'

const validators = {
  orno: { required },
  payee: { required },
}

class FormContainer extends Component {

  _onSubmit = (payload) => {
    const { dispatch } = this.props
    // change paydate to string MM/DD/YYYY
    const mod = payload.set('paydate_string', payload.get('paydate').format('L'))
    dispatch(savePayment(mod))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('paymentState', fromJS(res.payload.collection || {}).set('paydate', moment(res.payload.collection.paydate_string))))
          this.context.router.push(`/payments/${res.payload.collection.id}`)
        }
      })
  }

  _loadUnpaid = () => {
    const { __state, dispatch } = this.props
    dispatch(loadUnpaidBilling(__state.get('student_id')))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('paymentState.fees', fromJS(res.payload || [])))
        }
      })
  }

  _resetPayee() {
    const { dispatch } = this.props
    dispatch(actions.change('paymentState.student_id', 0))
    dispatch(actions.change('paymentState.student_id_input', ''))
    dispatch(actions.change('paymentState.payee', ''))
  }

  _triggerSubmit = () => {
    this.props.dispatch(actions.submit('paymentState'))
  }

  _addFee = () => {
    this.props.dispatch(actions.push('paymentState.fees', fromJS({
      id: 0,
      fee_id: 0,
      fee_code: '',
      fee_name: '',
      acct_code: '',
      amount: '',
    })))
  }

  _searchStudent = (e) => {
    const { dispatch, __state } = this.props

    if (__state.get('student_id') === Number(e.target.value)) {
      return false
    }

    if (!isInt(e.target.value)) {
      this._resetPayee()
      return false
    }
    dispatch(searchStudent(e.target.value))
      .then((res) => {
        if (res.error || res.payload.length === 0) {
          this._resetPayee()
        } else {
          dispatch(actions.change('paymentState.student_id', res.payload[0].id))
          dispatch(actions.change('paymentState.payee', res.payload[0].name))
        }
      })
  }

  _renderButtons(isShow) {
    const { __pending, __state } = this.props
    if (isShow) {
      return (
        <div className="row">
          <div className="col-sm-6">
            <Link to="/payments/new" className="btn btn-info">New Payment</Link>
          </div>
          <div className="col-sm-6 text-right">
            <Link to={`/print/receipt/${__state.get('id')}`} className="btn btn-warning" target="_blank">Print OR</Link>
          </div>
        </div>
      )
    } else {
      return (
        <div className="text-right">
          <button type="button" onClick={this._triggerSubmit} disabled={__pending} className="btn btn-success">Save Payment</button>
        </div>
      )
    }
  }

  render() {
    const { __state, __feesHasFetched, isShow, onSearchForm } = this.props

    if (!__feesHasFetched) {
      return <Loading />
    }

    const header = (
      <div className="row">
        <div className="col-sm-6">Payment Form</div>
        <div className="col-sm-6 text-right">
          <button type="button" onClick={onSearchForm} className="btn-icon btn-inline"><SearchIcon /></button>
        </div>
      </div>
    )

    return (
      <Panel header={header}>
        <Form
          model="paymentState"
          className="grid-form"
          validators={validators}
          onSubmit={this._onSubmit}
        >
          {this._renderButtons(isShow)}
          <hr />
          <FormPayment
            isShow={isShow}
            item={__state}
            onSearchStudent={this._searchStudent}
            onAddFee={this._addFee}
            loadUnpaid={this._loadUnpaid}
          />
          {this._renderButtons(isShow)}
        </Form>
      </Panel>
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

FormContainer.propTypes = {
  __state: PropTypes.object,
  __feesHasFetched: PropTypes.bool,
  __pending: PropTypes.bool,
  isShow: PropTypes.bool,
  onSearchForm: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __state: state.paymentState,
    __feesHasFetched: state.fee.get('hasFetched'),
    __pending: state.payment.get('pending'),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Payments/form-container.js